import ApiClient from '../../../../base/api';
import {
    GetResponsesCountersResponse,
    GetResponsesParams,
    HireStatusParams,
    ResponseItem,
    VacancyItem,
} from './interfaces';

const apiClient = new ApiClient();

export const responsesApi = {
    getResponseCounters: () => apiClient.get<GetResponsesCountersResponse>('/api/responses/counters'),
    getResponses: (params: GetResponsesParams, signal?: AbortSignal) =>
        apiClient.get<ResponseItem[]>('/api/responses', { params, signal }),
    getVacancyList: () => apiClient.get<VacancyItem[]>('/api/vacancy/list'),
    setResponseStatus: (responseId: number, hireStatus: HireStatusParams) =>
        apiClient.put<{ hireStatus: HireStatusParams }, void>(`/api/responses/${responseId}`, { hireStatus }),
    setResponseArchivationStatus: (responseId: number, isArchived: boolean) =>
        apiClient.put<{ isArchived: boolean }, void>(`/api/responses/${responseId}`, { isArchived }),
    markNewReponseAsRead: (responseId: number) =>
        apiClient.put<{ isNew: false }, void>(`/api/responses/${responseId}`, { isNew: false }),
    getResponseHistoryByWorkerId: (workerId: number) =>
        apiClient.get<ResponseItem[]>(`/api/responses/list?workerId=${workerId}`),
    translateResponse: (responseId: number) =>
        apiClient.post<undefined, ResponseItem>(`/api/responses/${responseId}/translate`),
};
